import React, { useState } from 'react';
import type { IconType } from '~/components/atom/Icon';
import TextButton from '~/components/atom/TextButton';
import { Body } from '~/components/atom/Typography';
import copyTextToClipboard from '~/util/copyTextToClipboard';

const text = {
  copied: 'Gekopieerd',
};

export type Props = {
  dataTestId?: string;
  className?: string;
  textToShare: string;
  label: string;
  icon?: IconType;
};

const CopyButton: React.FC<Props> = ({ textToShare, label, icon = 'copy' }) => {
  const [copied, setCopied] = useState(false);

  const onCopy = () => {
    void copyTextToClipboard(textToShare)
      .then(() => {
        setCopied(true);
      })
      .catch(() => {
        setCopied(false);
      });

    const timer = setTimeout(() => {
      clearTimeout(timer);
      setCopied(false);
    }, 1200);
  };

  return (
    <div>
      {copied ? (
        <Body margin={[null]} color={{ group: 'success' }}>
          {text.copied}
        </Body>
      ) : (
        <TextButton
          size="medium"
          icon={icon}
          onClick={onCopy}
          label={label}
          padding={[null]}
          underline
        />
      )}
    </div>
  );
};

export default CopyButton;
